import Swiper from 'swiper';
import {Navigation, EffectFade, Pagination, Autoplay, Scrollbar, EffectCards} from 'swiper/modules';
import 'swiper/scss';
Swiper.use([Navigation, EffectFade, Pagination, Autoplay, Scrollbar, EffectCards]);
import Component from "../models/Component";
import $ from 'jquery';

export default class FoamSteps extends Component {
  constructor(element, context) {
    super(element, context);

    var foamData = this.getData('foam');
    console.log(foamData);

    if (!foamData || !foamData.products) {
      return;
    }

    const $titleElement = this.element.find('.foam-filter-name');
    const $backgroundElement = this.element.find('.foam-background');
    const $bgcustom = this.element.find('.bg-custom');      
    const $stepsContainer = this.element.find('.foam-steps');
    const $buttons = $(".button-foam");

    function renderSteps(steps) {
      $stepsContainer.empty();
      
      $stepsContainer.html("");
      $.each(steps, function(index, step) {
        
        if (window.innerWidth > 1024) {
          var $stepElement = $("<div>", {
            class: "step-item w-full min-w-72 lg:min-w-[auto]"
          });
  
          $stepElement.html(
            '<img src="' + step.immagine_step + '" alt="Step Image" class="w-full aspect-square">' +
            '<div class="text-brown text-center !*medium py-3 md:pt-8">' + step.descrizione_step + '</div>'
          );
        }else{
          var $stepElement = $("<div>", {
            class: "step-item swiper-slide"
          });
  
          $stepElement.html(
            '<img src="' + step.immagine_step + '" alt="Step Image" class="w-full aspect-square">' +
            '<div class="text-brown text-center !*medium py-3 md:pt-8">' + step.descrizione_step + '</div>'
          );
        }
        
        $stepsContainer.append($stepElement);
      });
    }

    function updateFilter(productId) {
      const product = foamData.products[productId];
      if (!product) return;

      $titleElement.text(product.filterName).css("color", product.textColor);
      $backgroundElement.css("backgroundColor", product.bgColor);
      $bgcustom.css("backgroundColor", product.bgColor);

      renderSteps(product.steps);

      $buttons.removeClass("active_f").css({
        backgroundColor: "",
        borderColor: product.textColor,
        color: "#6D3A1F"
      });      

      $("#filter-" + productId).addClass("active_f").css({
        backgroundColor: product.textColor,
        borderColor: product.textColor,
        color: "#fff"
      });
    }

    $buttons.on("click", function () {
      const productId = $(this).data("product-id");
      updateFilter(productId);
    });

    if (foamData.default_product_id) {
      updateFilter(foamData.default_product_id);
    }
    


    // slider mobile
    this.mobileSlider = this.element.find('.swiper-product')[0];
    this.swiper = {};
    const scrollbarSwiper = this.element.find('.swiper-scrollbar-product')[0]


    $(() => {
      this.options = {
        spaceBetween: 20,
        allowTouchMove: true,
        centeredSlides: false,
        slidesPerView: 1.1,
        breakpoints: {
          768: {
            slidesPerView: 2.3,
            spaceBetween: 40,
          },

          1024: {
            slidesPerView: 3.3,
            spaceBetween: 60,
          }
        },
        scrollbar: {
          el: scrollbarSwiper,
        },
      };

      $(() => {
        this.init()
      })
    });
  }

  init() {
    this.swiper = new Swiper(this.mobileSlider, this.options);
  }

}
